import appVersion from "../../../configs/appVersion";
import classnames from "classnames";
import React from "react";
import logo from "../../../assets/images/logo-version-blanco.png";
import footerConfig from "../../../configs/footerConfig";

const Footer = ({ footerType }) => {
  const footerTypeArr = ["sticky", "static", "hidden"];

  const {
    institutionName,
    legalName,
    phone,
    address,
    showCurrentYear,
    fixedYear,
  } = footerConfig;

  const currentYear = showCurrentYear ? new Date().getFullYear() : fixedYear;

  return (
    <footer
      className={classnames("footer p-0", {
        "footer-static":
          footerType === "static" || !footerTypeArr.includes(footerType),
        "d-none": footerType === "hidden",
      })}
    >
      <div className="footer-colabogados py-4">
        <div className="container-fluid footer-content d-flex flex-column flex-md-row align-items-center justify-content-center">
          <div className="d-flex align-items-center mb-2 mb-md-0">
            <img
              src={logo}
              alt={institutionName}
              className="footer-logo me-3"
            />
          </div>
          <div className="footer-contact text-center text-md-start">
            <div>
              <strong>Tel:</strong> {phone}
            </div>
            <div>{address}</div>
          </div>
        </div>
      </div>

      <div className="footer-bottom-bar text-center py-2">
        © {currentYear} {legalName}. Todos los derechos reservados.
        <div><small>Versión {appVersion}</small></div>
      </div>
    </footer>
  );
};

export default Footer;
